import { useFilterBarHeight } from 'src/components/molecules/FilterBarContainer/styles';
import { TOP_BAR_HEIGHT } from 'src/components/templates/TopNavBar/styles';

export const useMaximumChartHeight = () => {
  const filterBarHeight = useFilterBarHeight();

  return `calc(100vh - ${filterBarHeight} - ${TOP_BAR_HEIGHT} - 100px)`;
};
